/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizationsettings_Noorganizationtitle3Inputs */

const zh_organizationsettings_noorganizationtitle3 = /** @type {(inputs: Organizationsettings_Noorganizationtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无组织`)
};

const en_organizationsettings_noorganizationtitle3 = /** @type {(inputs: Organizationsettings_Noorganizationtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No organization yet`)
};

const es_organizationsettings_noorganizationtitle3 = /** @type {(inputs: Organizationsettings_Noorganizationtitle3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no hay organización`)
};

/**
* | output |
* | --- |
* | "No organization yet" |
*
* @param {Organizationsettings_Noorganizationtitle3Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const organizationsettings_noorganizationtitle3 = /** @type {((inputs?: Organizationsettings_Noorganizationtitle3Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizationsettings_Noorganizationtitle3Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_organizationsettings_noorganizationtitle3(inputs)
	if (locale === "en") return en_organizationsettings_noorganizationtitle3(inputs)
	return es_organizationsettings_noorganizationtitle3(inputs)
});
export { organizationsettings_noorganizationtitle3 as "organizationSettings_noOrganizationTitle" }